import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class RangeInput extends Component {
  static propTypes = {
    defaultValue: PropTypes.string,
    readOnly: PropTypes.bool,
    previousValue: PropTypes.string,
    scale: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        representation: PropTypes.string.isRequired,
      }),
    ]),
    name: PropTypes.string.isRequired,
    showClear: PropTypes.bool,
    showHints: PropTypes.bool,
    showNA: PropTypes.bool,
    minHint: PropTypes.string,
    maxHint: PropTypes.string,
    triggerEvents: PropTypes.bool,
  };

  static defaultProps = {
    defaultValue: '',
    readOnly: false,
    previousValue: undefined,
    scale: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    showClear: true,
    showHints: false,
    showNA: false,
    minHint: 'Not at all likely',
    maxHint: 'Extremely likely',
    triggerEvents: true,
  };

  constructor(props) {
    super(props);
    this.state = { value: this.props.defaultValue };
  }

  // In the views you can listen to the custom event. You should use a parent
  // element if you want to bind before the react component is mounted.
  triggerCustomEvent(e, value) {
    if (this.props.triggerEvents) {
      const $node = $(e.target).closest('.Range');
      $node.trigger('range:change', [value]);
    }
  }

  handleClick(value, e) {
    e.preventDefault();
    if (this.props.readOnly) { return; }
    this.setState({ value });
    this.triggerCustomEvent(e, value);
  }

  clear = e => {
    e.preventDefault();
    this.setState({ value: '' });
  };

  renderButton = (key, value, representation = value, otherProps = {}) => {
    const selectedClass = value === this.state.value ? 'is-selected' : '';
    const previousClass = !selectedClass && value === this.props.previousValue
      ? 'Form-text--previous'
      : '';
    const readOnlyClass = this.props.readOnly ? 'read-only' : '';

    return (
      <a
        key={key}
        className={`Range-button ${selectedClass} ${readOnlyClass} ${previousClass}`}
        href="#"
        onClick={(e) => this.handleClick(value, e)}
        {...otherProps}
      >
        {representation}
      </a>
    );
  };

  renderButtons() {
    return this.props.scale.map((scaleItem, i) => (typeof scaleItem === 'object'
      ? this.renderButton(
        `value-${i}`,
        scaleItem.value,
        scaleItem.representation
      )
      : this.renderButton(`value-${i}`, scaleItem)));
  }

  render() {
    return (
      <div className="Range" data-name={this.props.name}>
        {this.props.showClear && this.state.value && (
          <a href="#" onClick={this.clear} className="Range-clear u-mb-2">
            Clear &times;
          </a>
        )}
        <div className="Range-buttons u-mt-2 u-mb-2">
          {this.props.showNA
            && this.renderButton('value-na', '', 'N/A', { style: { width: 50 } })}
          {this.renderButtons()}
        </div>

        {this.props.showHints && (
          <em className="hint u-float-right">{this.props.maxHint}</em>
        )}
        {this.props.showHints && (
          <em
            className="hint u-float-left"
            style={this.props.showNA ? { marginLeft: 50 } : {}}
          >
            {this.props.minHint}
          </em>
        )}

        <input
          type="hidden"
          name={this.props.name}
          value={this.state.value || ''}
        />
      </div>
    );
  }
}
